import React, { useState } from 'react';

const PaperCardSearch = ({
  title,
  authors = '',
  abstract,
  onSkip,
  onAdd,
  isInAgenda,
  date,
  time_start,
  time_end,
  location,
}) => {
  const [isAbstractVisible, setIsAbstractVisible] = useState(false);

  const toggleAbstractVisibility = () => {
    setIsAbstractVisible(!isAbstractVisible);
  };

  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });

  const formattedTime = `${time_start} - ${time_end}`;

  return (
    <div className="card">
      {isInAgenda && (
        <div className="voted-indicator">
          <i className="fas fa-check-circle"></i>
        </div>
      )}
      <h2>{title}</h2>
      <p className="authors">{authors || 'No authors listed'}</p>
      <div className="event-details">
        <div className="event-time">
          <div>{formattedDate}</div>
          <div>{formattedTime}</div>
        </div>
        <div className="event-location">
          {location}
        </div>
      </div>
      <div className={`abstract-container ${isAbstractVisible ? 'visible' : ''}`}>
        <p className="abstract">{abstract || 'No abstract available'}</p>
      </div>
      <button onClick={toggleAbstractVisibility} className="toggle-abstract">
        {isAbstractVisible ? 'Hide Abstract' : 'Show Abstract'}
      </button>
      <div className="separator"></div>
      <div className="buttons">
        <button className="add" onClick={onAdd} style={{ marginLeft: '16px', marginBottom: '0px',marginTop: '-14px' }}><i className="fas fa-plus"></i></button>
      </div>
    </div>
  );
};

export default PaperCardSearch;
